module.exports = __webpack_public_path__ + "static/media/arepa.min.968b49fa.svg";